import React from 'react'
import { componentMap } from '@/components/QuizStep'
import { usePaywallVariant } from '@/customHooks/usePaywallVariant'

export const AmplitudeVariationStep = ({
  data,
  onValid,
  onNextStep,
}: {
  data: any
  onValid: any
  onNextStep: any
}) => {
  const { variant, loading } = usePaywallVariant()
  const components = data.variations.find((el: any) => el.name === variant)?.components
  if (loading) {
    return (
      <div className="fixed top-0 left-0 w-full h-full bg-[white] dark:bg-black z-10 pointer-events-auto opacity-100">
        <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
          <svg viewBox="0 0 100 100" height="76" className="animate-spin">
            <use href="/svg/sprite.svg#spinner"></use>
          </svg>
        </div>
      </div>
    )
  }

  return (
    <>
      {components?.map((dataComponent: any, index: number) => {
        const Component = componentMap[dataComponent.component]
        if (!Component) return null
        return (
          <Component
            key={dataComponent.component + '-' + index}
            data={{ version: data.version, ...dataComponent }}
            onValid={onValid}
            onNextStep={onNextStep}
          />
        )
      })}
    </>
  )
}
